import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { fetchOptionsOverview } from '../lib/optionsApi';
import { useOptionsMode } from '../context/OptionsModeContext';
import { useOptionsLocale } from '../context/OptionsLanguageContext';

export const useOptionsOverviewState = () => {
  const { mode } = useOptionsMode();
  const { t } = useOptionsLocale();
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadOverview = useCallback(async ({ silent = false } = {}) => {
    if (!silent) {
      setLoading(true);
    }

    try {
      const data = await fetchOptionsOverview();
      setOverview(data);
      return data;
    } catch (error) {
      toast.error(error.response?.data?.detail || t('toasts.failedLoadOptions'));
      return null;
    } finally {
      if (!silent) {
        setLoading(false);
      }
    }
  }, [t, mode]);

  useEffect(() => {
    loadOverview();
  }, [loadOverview]);

  return {
    overview,
    loading,
    connected: Boolean(overview?.connected),
    reloadOverview: loadOverview,
  };
};

export default useOptionsOverviewState;